<template>
  <div class="form-group">
    <label for="name">Name</label>
    <BootstrapField
      type="text"
      name="name"
      placeholder="Name"
      rules="required"
    />
  </div>
  <div class="form-group">
    <label for="start_date">Start Datum</label>
    <BootstrapField
      type="datetime-local"
      name="start_date"
      :disabled="disableStartDate"
    />
    <div class="form-text">
      Wird beim anlegen von Schichten mit diesem Datum vorausgefüllt
    </div>
  </div>
  <div class="form-group">
    <QuillField name="description" label="Beschreibung" />
  </div>
  <div class="form-group">
    <h2>Teamleads</h2>
    <FieldArray name="teamleads" v-slot="{ fields, push, remove }">
      <div
        class="input-group mb-2"
        v-for="(entry, i) in fields"
        :key="entry.key"
      >
        <Field
          :name="`teamleads[${i}]`"
          v-slot="{ field, errors, errorMessage }"
          :rules="`required|uniqueTeamlead:${i}`"
        >
          <select
            v-bind="field"
            :id="`teamleads-${i}`"
            class="form-control"
            :class="{ 'is-invalid': !!errors.length }"
          >
            <option value="">--- Auswählen ---</option>
            <option v-for="u of users" :key="u.id" :value="u.id">
              {{ u.full_name }}
            </option>
          </select>
          <div class="input-group-append">
            <button class="btn btn-outline-danger" @click.prevent="remove(i)">
              <span class="fa fa-remove"></span>
            </button>
          </div>
          <span class="invalid-feedback" v-if="!!errors.length">{{
            errorMessage
          }}</span>
        </Field>
      </div>
      <div class="invalid-feedback mb-2">Ein Teamlead existiert doppelt.</div>
      <button class="btn btn-primary btn-small" @click.prevent="push('')">
        Hinzufügen
      </button>
    </FieldArray>
  </div>
</template>

<script>
import userService from "@/services/user.service.js";
import { Field, FieldArray } from "vee-validate";
import BootstrapField from "./BootstrapField.vue";
import QuillField from "./QuillField.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "TeamForm",
  components: { Field, BootstrapField, FieldArray, QuillField },
  props: ["disableStartDate"],
  data() {
    return {
      users: [],
    };
  },
  async beforeMount() {
    let response;
    try {
      response = await userService.index();
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
        window.scrollTo(0, 0);
      }
    }
    this.users = response.data;
  },
};
</script>

<style scoped></style>
